// module.exports = "https://rktbe.herokuapp.com";
module.exports = process.env.REACT_APP_API;
